import { render, staticRenderFns } from "./CmfPickupStep4.vue?vue&type=template&id=9d61489e&scoped=true"
import script from "./CmfPickupStep4.vue?vue&type=script&lang=js"
export * from "./CmfPickupStep4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d61489e",
  null
  
)

export default component.exports